import { CheckIcon } from './Icons.jsx';
import CorrectnessTally from './CorrectnessTally.jsx';
import HostTagPickPreview from './HostTagPickPreview.jsx';
import { rightCount } from '../lib/tagPick.js';
import './ClassifyQuestion.css';

/**
 * Teacher/projector view for a classify question — a static reference list
 * (no dropdowns) while students pick int/float on their own phones. On
 * reveal, shows each item's correct answer plus the reveal note and tally.
 */
export default function HostClassifyPreview({ payload, revealed, tally }) {
  if (payload.variant === 'tags') {
    return (
      <div className="stack host-classify-preview-stack">
        <HostTagPickPreview payload={payload} revealed={revealed} tally={tally} />
        {revealed && <CorrectnessTally tally={tally} />}
      </div>
    );
  }

  if (revealed) {
    return (
      <div className="stack host-classify-preview-stack">
        <div className="classify-list host-classify-list">
          {payload.items.map((item) => {
            const count = rightCount(tally, item);
            return (
              <div key={item.id} className="classify-row is-correct host-classify-row">
                <span className="classify-caption">{item.caption}</span>
                {count && (
                  <span className="host-classify-count">ตอบถูก {count.right}/{count.of} คน</span>
                )}
                <span className={`classify-answer-badge is-${item.answer}`}>{item.answer}</span>
              </div>
            );
          })}
        </div>

        {payload.revealNote && (
          <p className="classify-success text-center row" style={{ justifyContent: 'center', gap: '6px' }}>
            <CheckIcon size={18} />
            <span>{payload.revealNote}</span>
          </p>
        )}

        <CorrectnessTally tally={tally} />
      </div>
    );
  }

  return (
    <div className="stack host-classify-preview-stack">
      <div className="classify-list host-classify-list">
        {payload.items.map((item) => (
          <div key={item.id} className="classify-row host-classify-row">
            <span className="classify-caption">{item.caption}</span>
            <span className="classify-placeholder">{(payload.choices || ['int', 'float']).join(' / ')}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
